import { render, staticRenderFns } from "./CitypassCoupons.vue?vue&type=template&id=48d16494&"
import script from "./CitypassCoupons.vue?vue&type=script&lang=ts&"
export * from "./CitypassCoupons.vue?vue&type=script&lang=ts&"
import style0 from "./CitypassCoupons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports